import dayjs, { Dayjs } from 'lib/dayjs';
import { useCallback, useState } from 'react';
import { StoreInfo } from 'services/api/store';
import { FilterIdType } from '../utils/constants';

export interface FilterState {
  orderSn?: string;
  startDate?: string;
  endDate?: string;
  returnSn?: string;
  returnTrackingNumber?: string;
  sellerType?: Conversation.Trade.ISellerType | '';
  storeType?: Conversation.Trade.IStoreType | '';
  region?: General.UpperCaseRegion;
  follower?: '1' | '0';
  storeList?: StoreInfo[];
  reputation?: boolean;
  dueTimeEnd?: boolean;
  tradeCreateTimeStart?: string;
  tradeCreateTimeEnd?: string;
  itemName?: string;
  skuName?: string;
  sellerSku?: string;
  buyerNick?: string;
}
const useFilter = (filterType?: 'cancel' | 'return') => {
  const [query, setQuery] = useState<FilterState>(() => {
    if (!filterType) {
      return {};
    }
    // 与 OrderFilter/Filter 表单 initialValues 的默认日期范围保持一致，
    // 保证未点击「搜索订单」时，列表与导出请求也会带上默认的创建日期
    const start = dayjs(
      dayjs()
        .subtract(filterType === 'cancel' ? 6 : 30, 'days')
        .format('YYYY-MM-DD'),
    );
    const startDate = start.format('x');
    const endDate = dayjs(dayjs().format('YYYY-MM-DD')).add(1, 'day').subtract(1, 's').format('x');
    return { startDate, endDate };
  });
  const onQueryChange = useCallback(
    (e: {
      snType: FilterIdType;
      sn: string;
      dateRange?: [Dayjs, Dayjs];
      sellerType?: Conversation.Trade.ISellerType | '';
      storeType?: Conversation.Trade.IStoreType | '';
      region?: General.UpperCaseRegion;
      follower?: '1' | '0';
      storeList?: StoreInfo[];
      reputation?: boolean;
      dueTimeEnd?: boolean;
      tradeDateRange?: [Dayjs, Dayjs];
    }) => {
      const {
        sn,
        snType,
        sellerType = '',
        dateRange = [],
        tradeDateRange,
        storeType = '',
        ...others
      } = e;
      const [start, end] = dateRange!;
      const startDate = start ? dayjs(dayjs(start).format('YYYY-MM-DD')).format('x') : undefined;
      const endDate = start
        ? dayjs(dayjs(end).format('YYYY-MM-DD')).add(1, 'day').subtract(1, 's').format('x')
        : undefined;

      let tradeCreateTimeStart: string | undefined;
      let tradeCreateTimeEnd: string | undefined;
      if (tradeDateRange) {
        const [createStart, createEnd] = tradeDateRange;
        tradeCreateTimeStart = createStart
          ? dayjs(dayjs(createStart).format('YYYY-MM-DD')).format('x')
          : undefined;
        tradeCreateTimeEnd = createStart
          ? dayjs(dayjs(createEnd).format('YYYY-MM-DD')).add(1, 'day').subtract(1, 's').format('x')
          : undefined;
      }

      const query: FilterState = {
        startDate,
        endDate,
        sellerType,
        storeType,
        tradeCreateTimeStart,
        tradeCreateTimeEnd,
        ...others,
      };
      setQuery({
        orderSn: snType === FilterIdType.orderId ? sn : undefined,
        returnSn: snType === FilterIdType.returnId ? sn : undefined,
        returnTrackingNumber: snType === FilterIdType.returnTrackingNumber ? sn : undefined,
        itemName: snType === FilterIdType.itemName ? sn : undefined,
        skuName: snType === FilterIdType.skuName ? sn : undefined,
        sellerSku: snType === FilterIdType.sellerSku ? sn : undefined,
        buyerNick: snType === FilterIdType.buyerNick ? sn : undefined,
        ...query,
      });
    },
    [],
  );
  return {
    query,
    onQueryChange,
  };
};

export default useFilter;
